<template>
  <b-container class="pl-0 pr-0 pt-0 pb-0">
    <b-row v-if="loading">
      <b-col>
        <font-awesome-icon icon="spinner" size="lg" spin/>
      </b-col>
    </b-row>
    <b-row v-show="!loading">
      <b-col class="text-left">
        <b-form-group 
          id="programmeGroup"
          breakpoint="md"
          label="Programme"
          label-for="programme"
          :horizontal="horizontal"
          validated
        >
          <b-form-select v-if="hideNewField" v-model="selected_programme" :options="programmes" class="mb-3" id="programmeselect" @input="selectionMade($event)" @change="selectionMade($event)" required/>  
          <b-form-input v-if="!hideNewField" type="text" v-model="newProgrammeName" placeholder="New Programme name...." required/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="hideNewField && !loading && !noNew && !selected_programme">
      <b-col class="text-left">
        <b-button variant="primary" @click="addNew()">Add New</b-button>
      </b-col>
    </b-row>
    <b-row v-show="!hideNewField && !loading && !noNew">
      <b-col class="text-left">
        <b-button variant="success" @click="save()">Save</b-button>
      </b-col>
      <b-col class="text-right">
        <b-button variant="default" @click="cancelAdd()">Cancel</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import * as API from "@/services/API"

export default {
    name: 'ProgrammeSelection',
    // properties you can pass to this component
    props: {
        programme: {
          default: null,
          type: Number
        },
        noNew: true,
        horizontal: false
    },
    // this is reactive data and will be updated in the view
    data () {
      return {
        programmes: [],
        pagination: {
          totalRecords: 1,
          totalPages: 1,
          page: 1,
          pageSize: 1
        },
        hideNewField: true,
        newProgrammeName: '',
        // props down, events up.
        selected_programme: this.programme ? new String(this.programme) : null,
        loading: false
      }
    },
    created () {
      this.fetchData()
    },
    methods: {
        fetchData () {
          this.loading = true
          return API.getProgrammes(this.$root.token).then(res => {
            // convert data to something our dropdown can work it
            this.programmes = [ { value: null, text: 'Select a programme or Add New' } ]
            .concat(
              res.results.map(i => {
                return {
                  value: i.id,
                  text: i.name,
                  template: JSON.parse(i.template)
                }
              })
            )
            this.pagination = res.pagination
            this.loading = false
          })
        },
        addNew () {
          this.hideNewField = false
          this.newProgrammeName = ''
        },
        cancelAdd () {
          this.hideNewField = true
          this.newProgrammeName = ''
        },
        save () {
          if(this.newProgrammeName !== '') {
            return API.addProgramme(this.newProgrammeName,this.$root.token).then(response => {
              // success callback
              return this.fetchData().then(() => {
                this.hideNewField = true
                this.selected_programme = response.body.id
              })
            })
          }
        },
        selectionMade (e) {
          this.$emit('update:programme', this.programmes.reduce((accumulator, programme) => {
            if (programme.value === this.selected_programme) accumulator = programme;
            return accumulator;
          },null));
        }
    }
    
}
</script>

/* 
    "results": [
        {
            "href": "https://api.surveymonkey.com/v1/surveys/157598244",
            "nickname": "",
            "id": "157598244",
            "title": "Test Survey"
        }
    ],
    "pagination": {
        "totalRecords": 1,
        "totalPages": 1,
        "page": 1,
        "pageSize": 1
    }
}
*/


// WEBPACK FOOTER //
// src/components/ProgrammeSelection.vue